import { queryOptions } from '@tanstack/react-query';
import type { PublicBrandingView } from '@pqrs/contracts';
import { apiGet } from './client';

/**
 * Marca pública de la entidad (nombre, logo y color), la misma que viste el portal. En el backoffice el logo va
 * arriba en lugar del de Xiltrion y el color tiñe toda la app (`BrandTheme`); las tarjetas de marca invalidan esta
 * consulta al cambiarlos.
 */
export const publicBrandingKey = ['branding', 'public'] as const;
export const publicBrandingQuery = queryOptions({
  queryKey: publicBrandingKey,
  queryFn: () => apiGet<PublicBrandingView>('/public/branding'),
  staleTime: 10 * 60_000,
});
